







import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'StormImage',
  props: {
    image: String,
  },
})
export default class StormImage extends Vue {
}
